module.exports = __webpack_public_path__ + "static/media/wode.c010dc60.png";